import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { STEP_KEY_V2 } from "../../../../util/varibles/constants";
import { IActivityLog } from "../../../../util/varibles/interface";
import { AutoModeStatus } from "../AutoModeStatus";
import Steps from "../Steps";
import ArrivedFactory from "./_ArrivedFactory";
import ArrivedSite from "./_ArrivedSite";
import ArrivingToFactory from "./_ArrivingToFactory";
import Cleaning from "./_Cleaning";
import Completed from "./_Completed";
import Discharging from "./_Discharging";
import Harvesting from "./_Harvesting";
import TravellingToSite from "./_TravellingToSite";

function StepView({ activity_log, step }: { activity_log: IActivityLog[], step: number }) {
    const log = activity_log[step];

    switch (log?.key) {
        case STEP_KEY_V2.TRAVELLING_TO_SITE: {
            return <TravellingToSite log={log} />
        }
        case STEP_KEY_V2.ARRIVED_SITE: {
            return <>
                <ArrivedSite log={log} prev={activity_log[step - 1]} stepIndex={step} />
            </>
        }
        case STEP_KEY_V2.HARVESTING: {
            return <>
                <Harvesting log={log} stepIndex={step} />
            </>
        }
        case STEP_KEY_V2.ARRIVING_FACTORY: {
            return <>
                <ArrivingToFactory log={log} prev={activity_log[step - 1]} stepIndex={step} />
            </>
        }
        case STEP_KEY_V2.ARRIVED_FACTORY: {
            const dischargingStepIndex = activity_log.findIndex(item => item.key === STEP_KEY_V2.DISCHARGING);
            return <>
                <ArrivedFactory
                    log={log}
                    prev={activity_log[step - 1]}
                    discharging={activity_log[dischargingStepIndex]}
                    dischargingStepIndex={dischargingStepIndex}
                    stepIndex={step}
                />
            </>
        }
        case STEP_KEY_V2.DISCHARGING: {
            return <>
                <Discharging log={log} prev={activity_log[step - 1]} harvesting={activity_log.find(item => item.key === STEP_KEY_V2.HARVESTING)} stepIndex={step} />
            </>
        }
        case STEP_KEY_V2.CLEANING: {
            const harvestingSteps = activity_log.find(item =>
                item.key === STEP_KEY_V2.HARVESTING
            )?.real_sub_steps || [];
            const dischargingSteps = activity_log.find(item =>
                item.key === STEP_KEY_V2.DISCHARGING
            )?.real_sub_steps || [];

            return <>
                <Cleaning prev={activity_log[step - 1]} stepIndex={step} harvestingSteps={harvestingSteps} dischargingSteps={dischargingSteps} />
            </>
        }
        case STEP_KEY_V2.COMPLETED_HARVEST: {
            const prev = activity_log[step - 1];
            let harvestingSteps: NonNullable<IActivityLog["real_sub_steps"]> = [];
            let dischargingSteps: NonNullable<IActivityLog["real_sub_steps"]> = [];

            if (prev?.key === STEP_KEY_V2.DISCHARGING) {
                harvestingSteps = activity_log.find(item => item.key === STEP_KEY_V2.HARVESTING)?.real_sub_steps || [];
                dischargingSteps = prev.real_sub_steps || [];
            }

            return <>
                <Completed log={log} stepIndex={step} prev={prev} start={activity_log[0]} harvestingSteps={harvestingSteps} dischargingSteps={dischargingSteps} />
            </>
        }
        default:
            return <></>
    }
}

export default function HarvestSteps() {
    const [activity_log = []] = useTrackingOp(state => state.op?.activity_log);
    const [step] = useTrackingOp(state => state.step);

    return <div className="w-full h-full flex flex-col px-[20px]">
        <Steps activity_log={activity_log} step={step} />
        <div className="pt-3 w-full relative h-full flex-1 flex flex-col">
            <AutoModeStatus />
            <StepView activity_log={activity_log} step={step} />
        </div>
    </div>
}
